<template>
  <div style="margin: 0 0 12px;">

    <div class="content-input">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>供应商</label>
          <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <label>品牌</label>
          <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
            <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <commodity-type-list @confirm="getCommodityType($event)" :reSet="reSet" />
        </div>
        <div class="dialog-input-item">
          <label>审核状态</label>
          <el-select v-model="state" placeholder="Select" class="select-item">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="dialog-input-item">
          <label>商品名称</label>
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
        </div>



      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>



    <div class="content-table" style="width: 100%;">
      <div style="margin: 12px 0 16px;">
        <el-button type="primary" @click="batchUpdate(3)" v-loading="updateLoading">批量通过</el-button>
        <el-button type="danger" @click="batchUpdate(2)" v-loading="updateLoading">批量不通过</el-button>
      </div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          v-loading="listLoading"
          @cell-click="toggleSelection"
          @selection-change="selsChange"
          @header-click="selsAll"
          size="default"
          style="width: 100%"
          border
      >
        <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
        <el-table-column property="supplierName" label="供应商" width="70"/>
        <el-table-column property="brandName" label="品牌" width="60"/>
        <el-table-column property="commodityName" label="商品名称"/>
        <el-table-column property="" label="商品图片">
          <template #default="scope">
            <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
              <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" label="商品分类">
          <template #default="scope">
<!--            {{scope.row.commodityTypePreName}}{{scope.row.commodityTypeName}}-->
            {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
          </template>
        </el-table-column>
        <el-table-column property="specification" label="商品规格"/>
        <el-table-column property="measureUnitName" label="计量单位"/>
<!--        <el-table-column property="" label="系统库存" class-name="cursor">-->
<!--          <template #default="scope">-->
<!--            <span style="color: #409eff">{{scope.row.currentStockNum + scope.row.breakageNum}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column property="currentStockNum" label="系统库存" class-name="cursor">
              <template #default="scope">
                <span style="color: #409eff">{{scope.row.currentStockNum}}</span>
              </template>
        </el-table-column>

        <el-table-column property="breakageNum" label="报损库存" class-name="cursor">
          <template #default="scope">
            <span style="color: #409eff;">{{scope.row.breakageNum}}</span>
          </template>
        </el-table-column>
        <el-table-column property="takeNum" label="盘点库存">
          <template #default="scope">
            <span>{{scope.row.takeNum}}</span>
          </template>
        </el-table-column>
        <el-table-column property="" label="图片" >
          <template #default="scope">
            <div v-if="scope.row.stockTakeImgList.length > 0" class="cursor" @click="takeImgList(scope.row)">
              <el-image class="item-img" fit="cover" :src="scope.row.stockTakeImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="retailPrice" label="备注" width="175" class-name="cursor">
          <template #default="scope">
            <TakeRemark :userRemarkList="scope.row.stockTakeRemarkList" />
          </template>
        </el-table-column>
        <el-table-column property="" label="状态" width="70">
          <template #default="scope">
            <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'审核中':scope.row.state == 2?'不通过':scope.row.state == 3?'已通过':'' }}</p>
          </template>
        </el-table-column>
        <el-table-column property="" label="操作" width="94">
          <template #default="scope">
            <el-space wrap>
              <el-button v-if="scope.row.state == 1 || scope.row.state == 2" @click="updateState(scope.row, 3)" size="small" type="primary" v-loading="scope.row.updateLoading">通过</el-button>
              <el-button v-if="scope.row.state == 1 || scope.row.state == 3" @click="updateState(scope.row, 2)" size="small" type="danger" v-loading="scope.row.updateLoading">不通过</el-button>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";
import {getFormData, postFormData} from "@/api/api";
import {
  stockTakeCommodityPageList, listAllBrand,
  listAllSupplier, updateStockTakeCommodityState
} from "@/api/url";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import TakeRemark from "@/components/StockTakeRemark/TakeRemark";
import Dialog from "@/assets/js/dialog";
import SearchComponents from "@/components/SearchComponents";
import UpdateAuditState from "@/views/stock/components/UpdateAuditState";
import TakeRemarkDialog from "@/components/StockTakeRemark/TakeRemarkDialog";
import BreakageInfoDialog from "@/views/stock/components/BreakageInfoDialog";
import commodityTypeList from "@/components/commodityTypeList";
import CommodityStockDialog from "@/views/stock/components/CommodityStockDialog";

export default {
  name: "StockListDialog",
  components: { TakeRemark, SearchComponents, commodityTypeList },
    props: {
    value: Object
  },
  data() {
    return {
      auditForm: this.value.auditForm,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待提交', value: 0},
        {label: '审核中', value: 1},
        {label: '不通过', value: 2},
        {label: '已通过', value: 3},
      ],
      state: 1,

      idArray: [],

      batchLoading: false,

      limitState: false,

      //搜索
      searchTypeList: [
        {label : '商品名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      commodityTypeId: 0,
      commoditySubTypeId: 0,
      reSet: false

    }
  },
  methods: {

    getCommodityType(e) {
      console.log(e)
      this.commodityTypeId = e[0]
      this.commoditySubTypeId = e[1]
      this.reSet = e[2]
    },

    // 重置参数
    refreshParam() {
      // this.isChecked = false;
      this.reSet = true
      this.supplierId = 0;
      this.brandId = 0;
      this.state = 1;
      this.limitState = false;
      this.searchValue = '';
      this.searchType = 1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },


    cancel() {
      this.$emit("close");
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '商品图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    takeImgList(row) {
      let _title = '';
      _title = '盘点图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.stockTakeImgList,
          id: this.auditForm.id,
          width: 908,
          from: 3,
          hideBtn: row.state == 3
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },


    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '报损库存') {
        Dialog.open({
          title: '报损出库',
          component: BreakageInfoDialog,
          data: {
            breakageForm: row,
            width: '500px'
          },
          close: () => {
          }
        })
      }

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '备注',
          component: TakeRemarkDialog,
          data: {
            id: row.id,
            width: '800px'
          },
          close: () => {
            row['stockTakeRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
            // this.getPage()
          }
        })
      }

      if(column.label == '系统库存') {
        let _title = '单品库存详情';
        let stockForm = Object.assign({}, row);
        stockForm.shopId = this.auditForm.shopId
        Dialog.open({
          title: _title,
          component: CommodityStockDialog,
          data: {
            stockForm: stockForm,
            // ids: idx,
            width: '1100px',
          },
          close: (result) => {
            this.getPage()
          }
        })
      }

    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['limitState'] = this.limitState?1:0;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['stockTakeId'] = this.auditForm.id;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['state'] = this.state;
      param['commodityTypeId'] = this.commoditySubTypeId>0?this.commoditySubTypeId:this.commodityTypeId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(stockTakeCommodityPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    updateState(row, state) {
      let _title = ''
      if(state == 2) _title = '审核不通过'
      if(state == 3) _title = '审核通过'
      let arr = []
      arr.push(row.id)
      Dialog.open({
        title: _title,
        component: UpdateAuditState,
        data: {
          state: state,
          idArr: arr,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    batchUpdate(state) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择审核的商品',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量' + (state == 2?'不通过':'通过') + '商品审核吗？').then(() => {
        this.batchLoading = true
        let param = {}
        param['idArr'] = this.idArray
        param['state'] = state
        postFormData(updateStockTakeCommodityState, param).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
            this.getPage()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        })
      })
    },


    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },


  },

  mounted() {
    this.getPage()
    this.getSupplierList()
    this.getBrandList()
  }


}
</script>

<style scoped>
.stock-info{
  display: flex;
  align-items: center;
  justify-content: space-around;
  /*background-color: #f5f7fa;*/
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 24px;
}
.item-img {
  width: 56px;
  height: 56px;
}
.stock-info-img {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.stock-info-text {
  width: 25%;
}

.info-title{
  /*width: 70px;*/
  /*text-align: right;*/
  font-weight: bold;
}

.info-item {
  display: flex;
  align-items: center;
  margin: 3px 0;
}

.add {
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  border: 1px dashed #ececec;
  font-size: 24px;
  cursor: pointer;
  float: left;
}

</style>
